import { registerModuleClicks } from "@shared/lingxi/kit";
import { getAdsBySlotId } from "@shared/apis/da";
import "@shared/dom-polyfills/classList";
import "@shared/dom-polyfills/dataset";

registerModuleClicks(require("./lingxi-aside.json"));

function loadDa() {
  getAdsBySlotId(62)
    .then(ads => {
      const ad = (ads || [])[0];
      if (!ad) return;
      const { url, adMaterialMap, adDeliveryId, activityName } = ad;
      const { imageUrl } = adMaterialMap || {};
      return { url: url.replace(/[?&]phx_ad_delivery_id=[^&\b]*/, ""), imageUrl, adDeliveryId, activityName };
    })
    .then(prepareDaNode);
}

function prepareDaNode({ url, imageUrl, adDeliveryId, activityName } = {}) {
  const d = window.document;
  const nodeRoot = d.getElementById("aside-da");
  if (!nodeRoot) return;
  if (!url || !imageUrl) {
    nodeRoot.classList.add("aside-da--unready");
    return;
  }

  nodeRoot.dataset.deliveryId = adDeliveryId;
  nodeRoot.dataset.actName = activityName;
  const nodeLink = d.getElementById("aside-da__link");
  const nodeImage = d.getElementById("aside-da__image");
  nodeLink.href = url;
  nodeImage.src = imageUrl;
  nodeRoot.classList.remove("aside-da--unready");
}

loadDa();

require("./aside.less");